import React from 'react'
import styled from 'styled-components'
import { WindowWidthSensor } from 'libreact/lib/WindowWidthSensor'
import HelpIcon from '../../HelpIcon'
import Rows from '../Rows'
import Column from '../Column'
import LeftColumn from '../LeftColumn'
import Buttons from './Buttons'
import StartingAge from './StartingAge'
import EndingAge from './EndingAge'
import SmallExtraColumns from './SmallExtraColumns'
import Value from '../Value'
import Description from '../Description'

const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`

const Item = styled(Column)`
  font-weight: 600;
  text-align: center;
  font-size: 14px;
  padding: 0 15px;
`

const HelpIconWithPadding = styled(HelpIcon)`
  display: inline-block;
  margin-right: -24px;
`

const customRow = {
  label: '',
  enabled: true,
  value: '',
  custom: true,
  startingAge: 1,
  endingAge: 5,
}

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  @media (max-width: 768px) {
    display: block;
  }
`

const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export default (props) => (
  <WindowWidthSensor>
    {({ width }) => (
      <>
        <Description heading='Monthly Costs'>
          Enter the estimated monthly expenses in the fields below that you expect you'll be paying for. You can include (and remove) categories easily by clicking the checkbox next to each item. All pre-populated expense amounts are based on average costs of each item. Click next to continue.
        </Description>
        <Header>
          <LeftColumn />
          <Item>
            Expense amount per month <HelpIconWithPadding label='Expense amount per month' description="The estimated monthly amount that you'll be spending per each expense category." />
          </Item>
          <Item size='smaller'>
            Starting age
            <br/>
            (0-24) <HelpIconWithPadding label='Starting age' description="The child's age (in years) that you estimate you'll start paying for each expense on a monthly basis." />
          </Item>
          <Item size='smaller'>
            Ending age
            <br/>
            (0-24) <HelpIconWithPadding label='Ending age' description="The child's age (in years) you estimate you'll stop paying for the expense item on a monthly basis." />
          </Item>
        </Header>
        <Rows baseName='monthlyCosts' withCustom={customRow} bold {...props}>
          {({ label, ...rest }) => (
            <Container>
              <MainContainer>
                {label}
                <Value {...rest} />
              </MainContainer>
              {width >= 768 ? (
                <>
                  <StartingAge {...rest} />
                  <EndingAge {...rest} />
                </>
              ) : (
                <SmallExtraColumns {...rest} />
              )}
            </Container>
          )}
        </Rows>

        <Buttons {...props} />
      </>
    )}
  </WindowWidthSensor>
)
